import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import Card from '../../../components/Card.react';
import { SavedJob } from '../../../stores/SavedJobsStore';

const SavedJobHeader = ({ savedJob }) => (
  <div className='saved-job-card-header'>
    {savedJob.id} | {savedJob.name}
  </div>
);

const SavedJobSteps = ({ savedJobRequestJson }) => (
  <div>
    {savedJobRequestJson.config.map((step, index) =>
      <div key={index} className='saved-job-step'>
        {step.name || step.jobType}
      </div>)}
  </div>
);

const SavedJobCard = ({ savedJob, selected, maxPerRow, onClick }) => (
  <Card
    header={<SavedJobHeader savedJob={savedJob} />}
    onClick={() => onClick(savedJob)}
    maxPerRow={maxPerRow}
    selected={selected}
    noPad
  >
    <SavedJobSteps savedJobRequestJson={savedJob.config} />
  </Card>
);

export default SavedJobCard;

SavedJobHeader.propTypes = {
  savedJob: PropTypes.shape({
    id: PropTypes.int,
    name: PropTypes.string,
  }),
};

SavedJobSteps.propTypes = {
  savedJobRequestJson: PropTypes.shape({
    config: PropTypes.array,
  }),
};

SavedJobCard.propTypes = {
  savedJob: PropTypes.instanceOf(SavedJob),
  selected: PropTypes.bool,
  maxPerRow: PropTypes.number,
  onClick: PropTypes.func,
};
